// Almacenamiento local en IndexedDB para trabajar sin internet.
// Se usa IndexedDB (y no localStorage) porque las fotos del E-14 pesan
// varios MB y localStorage solo admite ~5 MB en total.
// - "pendientes": registros hechos sin conexión que esperan enviarse
// - "cache": última copia de datos leídos del servidor (catálogos, actas)

const NOMBRE_BD = "control-electoral";
const VERSION_BD = 1;
export const EVENTO_PENDIENTES = "pendientes-cambio";

let conexionBD = null;

const abrirBD = () => {
  if (!conexionBD) {
    conexionBD = new Promise((resolve, reject) => {
      const solicitud = indexedDB.open(NOMBRE_BD, VERSION_BD);
      solicitud.onupgradeneeded = () => {
        const bd = solicitud.result;
        if (!bd.objectStoreNames.contains("pendientes")) bd.createObjectStore("pendientes", { keyPath: "id" });
        if (!bd.objectStoreNames.contains("cache")) bd.createObjectStore("cache", { keyPath: "clave" });
      };
      solicitud.onsuccess = () => resolve(solicitud.result);
      solicitud.onerror = () => {
        conexionBD = null;
        reject(solicitud.error);
      };
    });
  }
  return conexionBD;
};

// ejecuta una operación sobre un almacén y devuelve su resultado
const operar = async (almacen, modo, accion) => {
  const bd = await abrirBD();
  return new Promise((resolve, reject) => {
    const transaccion = bd.transaction(almacen, modo);
    const solicitud = accion(transaccion.objectStore(almacen));
    transaccion.oncomplete = () => resolve(solicitud?.result);
    transaccion.onerror = () => reject(transaccion.error);
    transaccion.onabort = () => reject(transaccion.error);
  });
};

const avisarCambioPendientes = () => window.dispatchEvent(new Event(EVENTO_PENDIENTES));

// ─── pendientes ───
export const listarPendientes = async () => {
  const todos = (await operar("pendientes", "readonly", (store) => store.getAll())) ?? [];
  return todos.sort((a, b) => a.creadoEn - b.creadoEn);
};

export const guardarPendiente = async (pendiente) => {
  await operar("pendientes", "readwrite", (store) => store.put(pendiente));
  avisarCambioPendientes();
};

export const eliminarPendiente = async (id) => {
  await operar("pendientes", "readwrite", (store) => store.delete(id));
  avisarCambioPendientes();
};

// ─── caché de lecturas ───
export const guardarCache = (clave, valor) =>
  operar("cache", "readwrite", (store) => store.put({ clave, valor, guardadoEn: Date.now() })).catch((error) =>
    console.error("No se pudo guardar la copia local:", error)
  );

export const leerCache = async (clave) => {
  try {
    const registro = await operar("cache", "readonly", (store) => store.get(clave));
    return registro?.valor ?? null;
  } catch (error) {
    console.error("No se pudo leer la copia local:", error);
    return null;
  }
};

// pide al navegador no borrar estos datos si se queda sin espacio
export const pedirAlmacenamientoPersistente = () => {
  navigator.storage?.persist?.().catch(() => {});
};
